import { gql } from "@apollo/client";

export const createSavedViewMutation = gql`
    mutation CreateSavedView($createSavedViewInput: CreateSavedViewInput!) {
        createSavedView(createSavedViewInput: $createSavedViewInput) {
            id
            name
            page
            pageQuery
        }
    }
`;

export const updateSavedViewMutation = gql`
    mutation UpdateSavedView($updateSavedViewInput: UpdateSavedViewInput!) {
        updateSavedView(updateSavedViewInput: $updateSavedViewInput) {
            id
            name
            page
            pageQuery
            isDefault
        }
    }
`;

export const deleteSavedViewMutation = gql`
    mutation DeleteSavedView($id: String!) {
        deleteSavedView(id: $id) {
            id
        }
    }
`;
